import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { from } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { AuthService } from './auth.service';
import { DistrictGroup } from '@app/shared';


@Injectable({
    providedIn: 'root'
})
export class DistrictGroupService {

    constructor(
        private http: HttpClient,
        private authService: AuthService
    ) { }

    list() {
        const headers = this.authService.authHeaders();
        return this.http.get<DistrictGroup[]>(
            '/api/scheduling/districtgroup/',
            { headers }
        ).pipe(
            switchMap(response => response)
        );
    }

    get(id: number) {
        const headers = this.authService.authHeaders();
        return this.http.get<DistrictGroup>(
            '/api/scheduling/districtgroup/' + id + '/',
            { headers }
        );
    }

    create(group: DistrictGroup) {
        const headers = this.authService.authHeaders();
        return this.http.post<DistrictGroup>(
            '/api/scheduling/districtgroup/',
            group,
            { headers }
        );
    }

    update(group: DistrictGroup) {
        const headers = this.authService.authHeaders();
        return this.http.put<DistrictGroup>(
            '/api/scheduling/districtgroup/' + group.id + '/',
            group,
            { headers }
        );
    }

    delete(group: DistrictGroup) {
        const headers = this.authService.authHeaders();
        return this.http.delete(
            '/api/scheduling/districtgroup/' + group.id + '/',
            { headers }
        );
    }
}
